import { cn } from '@civilgrid/ui/utils';
import { getAvatarLetters } from '~/common/authUtils';
import type { User } from '~/common/types';
import Icon from '../Icon';

interface Props {
  me?: User | null;
  name?: string;
  className?: string;
}

const getInitials = (name: string): string => {
  const nameParts = name.trim().split(' ');

  if (nameParts.length === 1) {
    // if only first name, return the first letter twice
    return nameParts[0].charAt(0).toUpperCase() + nameParts[0].charAt(0).toUpperCase();
  } else if (nameParts.length === 2) {
    // return regular last initials
    return `${nameParts[0].charAt(0).toUpperCase()}${nameParts[1].charAt(0).toUpperCase()}`;
  } else {
    // more than 2 words in name --> return initial of first and last words
    return `${nameParts[0].charAt(0).toUpperCase()}${nameParts[nameParts.length - 1].charAt(0).toUpperCase()}`;
  }
};

/**
 * @deprecated Use `AvatarIcon` from `@civilgrid/ui/components` instead. Kept only for
 * civil-search, which is being retired in favour of GridTools. Do not add new usages.
 */
export default function ({ me, name, className }: Props) {
  let initials: string | undefined;

  if (me) {
    initials = getAvatarLetters(me);
  } else if (name) {
    initials = getInitials(name);
  }

  return (
    <div
      className={cn(
        'flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-primary font-bold uppercase text-white',
        className,
      )}
    >
      {initials ? initials : <Icon icon="user" />}
    </div>
  );
}
